<template>
	<div>
		<breadcrumb :routerList="[{to:'/pricenewCG',title:'特价管理'},{title:'特价信息'}]" />
		<div class="bigDiv ahstyles">
			<div class="h-piece">
				<div>
					<div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
						<h1>特价立项信息</h1>
					</div>
					<div class="pieceCon n-bu">
						<div class="h-pieceCon2">
							<div class="h-formLine ">
								<el-form label-position=right :model="offer" ref="formLabelAlign2" :inline="true" :rules="rule" class="demo-ruleForm h-formbLine">
									<el-form-item label="创建人" class="h-elformWrap-2 " prop="cuname" v-if="offer.cuname">
										<el-input v-model="offer.cuname" placeholder="" readonly disabled>
										</el-input>
									</el-form-item>

									<el-form-item label="创建人编码" class="h-elformWrap-2 " prop="cucode" v-if="offer.cucode">
										<el-input v-model="offer.cucode" placeholder="" readonly disabled>
										</el-input>
									</el-form-item>

									<el-form-item label="创建时间" class="h-elformWrap-2 " prop="cdate" v-if="offer.cdate">
										<el-input v-model="offer.cdate" placeholder="" readonly disabled>
										</el-input>
									</el-form-item>

									<el-form-item label="特价类型" class="h-elformWrap-2" :prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'category':''">
										<brselect v-if="shenpiyemian||yitijiaoshenpi||chakanyemian" clearable category="category_cgtejia" :v="offer.category"
										 v-model="offer.category" @change="tejialeixingxuanze" :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
										</brselect>

										<brselect v-else clearable category="category_cgtejia" :v="offer.category" v-model="offer.category" @change="tejialeixingxuanze"
										 :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
										</brselect>
									</el-form-item>

									<el-form-item label="选择供应商" class="h-elformWrap-2" style="position:relative" :prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'xuanzhongren':''">
										<el-input v-model="offer.xuanzhongren" placeholder="" readonly :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'>
											<i class="el-icon-search el-input__icon" slot="suffix" @click="tanchuxuanzeren" v-if='!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian'>
											</i>
										</el-input>
									</el-form-item>

									<el-form-item v-if="xuanzequyu" label="区域" class="h-elformWrap-2" :prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'type':''">
										<brselect clearable category="neibu_haiwai_area" :v="offer.type" v-model="offer.type" @change="xuanzequyufangfa"
										 :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian">
										</brselect>

									</el-form-item>

									<el-form-item v-if="xiangmuxinxishow" label="项目名称" class="h-elformWrap-2 " prop="xiangmuname">

										<el-input style="width: 500%" v-model="offer.xiangmuname" placeholder="" readonly disabled>
										</el-input>

									</el-form-item>
									<br>

									<el-form-item v-if="xiangmuxinxishow" label="项目id" class="h-elformWrap-2 " prop="xiangmucode">

										<el-input v-model="offer.xiangmucode" placeholder="" readonly disabled>
										</el-input>

									</el-form-item>

									<el-form-item v-if="cesuanshow" label="测算版本查看" class="h-elformWrap-2 " prop="xiangmucode">

										<el-button type="text" size="small" class="h-tableLink h-btn" @click="cesuanbanbenchakan">测算版本查看
										</el-button>

									</el-form-item>

									<showxuanzeren :visible.sync="xuanzeren" ddlx="9" v-if="xuanzeren" @choseObj="shiyongrenxuanze" oneflag title="选择供应商"
									 :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian' />
									<shouwuliao :visible.sync="xuanwuliao" v-if="xuanwuliao" :type="offer.type" @choseObj="chanpinxinghaochangetype"
									 :usercode="offer.userCode" oneflag title="选择物料" :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian' />
									<br>
									<el-form-item label="特价有效期" class="h-elformWrap-2" :prop="!(shenpiyemian||chakanyemian||yitijiaoshenpi)?'youxiaoqi':''">
										<template>
											<div class=" block">
												<el-date-picker v-model="offer.youxiaoqi" type="daterange" range-separator=" 至 " start-placeholder="开始日期"
												 end-placeholder="结束日期" style="width: 6rem" value-format="yyyy-MM-dd" :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'>
												</el-date-picker>
											</div>
										</template>
									</el-form-item>

									<br>
									<el-form-item label="特价立项说明" class="h-elformWrap-2 " :prop="offer.category==4?'tejiashuoming':''">
										<el-input v-model="offer.tejiashuoming" :placeholder="shenpiyemian||yitijiaoshenpi||chakanyemian?'':'请输入说明'"
										 style="width:7rem" :disabled='shenpiyemian||yitijiaoshenpi||chakanyemian'></el-input>
									</el-form-item>
									<br>
									<el-form-item label="立项资料上传" class="h-elformWrap-2" prop="upload">
										<brupload style="width: 10rem" tips="" :refid="fujianId" :reftype="zhengmingziliao" :uploadflag="!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian"
										 :delflag="!shenpiyemian&&!yitijiaoshenpi&&!chakanyemian">
										</brupload>
									</el-form-item>
									<br>
									<el-form-item label="审批意见" class="h-elformWrap-2 " :prop="shenpiyemian?'shenheyijian':''" v-if="shenpiyemian||bohuiyemian">
										<el-input style="width: 10rem" v-model="offer.shenheyijian" placeholder="请输入" :disabled="bohuiyemian||yitijiaoshenpi">
										</el-input>
									</el-form-item>


								</el-form>
							</div>
						</div>
					</div>
				</div>

				<!--  特殊直扣  -->
				<div class="N-chan" v-if="offer.category==13">
					<div class="h-pieceTitle2">
						<h1>特价型号信息</h1>
					</div>
					<div class="yxtable">
						<el-table ref="multipleTable" :data="tableData3" style="width: 100%" border>
							<el-table-column type="index" width="40" label="#">
							</el-table-column>

							<el-table-column prop="productId" label="产品编码" width="210" :show-overflow-tooltip="true">
							</el-table-column>
							<el-table-column prop="productName" label="产品型号" min-width="230" :show-overflow-tooltip="true">
							</el-table-column>
							<el-table-column prop="hid" label="产品大类" width="140" :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<dictname category="product_level" :v="scope.row.hid" />
								</template>
							</el-table-column>
							<el-table-column prop="unitPrice" label="基准价" width="90" :show-overflow-tooltip="true">
							</el-table-column>
							<el-table-column prop="jineorzhekou" label="申请特价" width="110">
								<template slot-scope="scope">
									<el-input class="h-tableInput" v-model="scope.row.jineorzhekou" placeholder="" type="number" :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="bizhong" label="币种" :show-overflow-tooltip="true" width="80">
							</el-table-column>

							<el-table-column prop="avaiNumber" label="数量" width="110" v-if="(!shenpiyemian && !yitijiaoshenpi && !chakanyemian) || this.sta <= 1">
								<template slot-scope="scope">
									<el-input class="h-tableInput" v-model="scope.row.avaiNumber" placeholder="" :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"
									 @blur="kaishishifu(scope.row)"></el-input>
								</template>
							</el-table-column>

							<el-table-column prop="avaiNumber" label="剩余数量" width="110" v-if="(shenpiyemian || yitijiaoshenpi || chakanyemian) && this.sta > 1">
								<template slot-scope="scope">
									<el-input class="h-tableInput" v-model="scope.row.avaiNumber" placeholder="" :disabled="shenpiyemian||yitijiaoshenpi||chakanyemian"
									 @blur="kaishishifu(scope.row)"></el-input>
								</template>
							</el-table-column>

							<el-table-column prop="totalNumber" label="申请数量" width="110" v-if="(shenpiyemian || yitijiaoshenpi || chakanyemian) && this.sta > 1">
								<template slot-scope="scope">
									<el-input class="h-tableInput" v-model="scope.row.totalNumber" placeholder="" disabled="true"
									 @blur="kaishishifu(scope.row)"></el-input>
								</template>
							</el-table-column>


							<el-table-column label="操作" width="220" fixed="right" v-if="shenpiyemian==false&&yitijiaoshenpi==false&&bohuiyemian==false">
								<template slot-scope="scope">
									<el-button type="text" size="small" class="h-tableLink h-btn" @click="delPlan(scope.$index,scope.row)" v-if="!chakanyemian">删除
									</el-button>
									<el-button type="text" size="small" class="h-tableLink h-btn" @click="tejiachanpinshiyongqingkuang(scope.$index,scope.row)"
									 v-if="chakanyemian==true">特价产品使用情况
									</el-button>
								</template>
							</el-table-column>
						</el-table>

						<div class="h-tableAdd" @click="adds" v-if="chakanyemian?false:(!shenpiyemian&&!yitijiaoshenpi&&!bohuiyemian)">
							<a>新增一行</a>
						</div>
					</div>
				</div>

				<br>
				<div style="margin:0 20px " v-if="cesuanshow">
					<div class="yx_progressBar">
						<div class="yxExtra" style="right: 2.5rem;top:0.4rem">
							<div style="margin-bottom: 0.2rem;"></div>
						</div>
						<div class="yx_topTip">
							<div class="leftdes">
								<span>材料毛利：</span><span class="percent">{{cailiaomaoli}}</span>
							</div>
							<div class="leftdes">
								<span>经营贡献：</span><span class="percent">{{jingyinggongxian}}</span>
							</div>
							<div class="leftdes">
								<span>经营贡献率：</span><span class="percent">{{jingyinggongxianlv}}</span>
							</div>
							<div class="leftdes">
								<span>利润：</span><span class="percent">{{lirun}}</span>
							</div>
							<div class="leftdes">
								<span>利润率：</span><span class="percent">{{lirunlv}}</span>
							</div>
						</div>

					</div>
				</div>


				<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showhistoryid" />


			</div>
			<!--				<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-top:20px;">批量导出</el-button>-->
			<el-row style="display: flex;justify-content: center;margin: 30px 0;">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="fanhuishangye">返回</el-button>
				<el-button class="h-btn h-bBtn h-bggreen" @click="zancuntijiao(0)" v-if="chakanyemian?false:((!shenpiyemian?bohuiyemian?false:(offer.category!=null):false)&&!yitijiaoshenpi)">
					暂存
				</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="zancuntijiao(1)" v-if="chakanyemian?false:((!shenpiyemian?bohuiyemian?false:(offer.category!=null):false)&&!yitijiaoshenpi)">
					确认提交
				</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="chongxintijiao" v-if="bohuiyemian&&!yitijiaoshenpi">
					重新提交
				</el-button>
				<el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="tongguobohui(1)" v-if="shenpiyemian">驳回
				</el-button>
				<el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="tongguobohui(2)" v-if="shenpiyemian">通过
				</el-button>
				<el-button class="h-btn  h-bgblueQ2" @click="genzongLiuch" v-if="showhistoryid!=null">
					跟踪审批
				</el-button>

			</el-row>
		</div>
	</div>
</template>


<script>
	import shouwuliao from '../../../components/dialog/wxwl-cgall'
	import showxuanzeren from '../../../components/dialog/selectgys'
	import big from 'big.js'
	import ss from '../../../api/SystemService';

	export default {

		components: {
			showxuanzeren,
			shouwuliao
		},

		data() {
			return {

				fujianId: null,

				cailiaomaoli: '%',

				jingyinggongxian: '',

				jingyinggongxianlv: '%',

				lirun: '',

				lirunlv: '%',

				cesuanshow: false,

				cesuanid: '',

				xiangmuxinxishow: false,

				columndata: [],

				nidmap: {},

				dengjixuanzelist: [],

				xuanzedengji: false,

				xuanzequyu: false,

				shiyongrenbizhong: '',

				chakanyemian: false,

				showhistoryid: null,

				showhistory: false,

				//已提交审批
				yitijiaoshenpi: false,

				//驳回页面
				bohuiyemian: false,

				//ywid
				ywid: null,

				//instid
				instid: null,

				//taskid
				taskid: null,

				//特价版本id
				rversion: null,

				//是否审批页面
				shenpiyemian: false,

				//要删除的特价产品id
				yaoshanchude: [],

				zhekoupanduan: false,

				shifoutaijie: false,

				//上传的证明资料的type名
				zhengmingziliao: 'zhengmingziliao',

				//暂存提交特价版本id
				zancuntijiaobanben: '',

				xuanwuliao: false,

				xiangmuchanpinmap: {},

				wuliaocode: [],

				xiangmumingchengOptions: [],

				offer: {

					gaojiadijia: '',

					cuname: '',

					cucode: '',

					type: '',

					pid: '',

					youxiaoqi: ['', ''],

					category: '',

					//产品型号选中值
					chanpinxinghao: '',

					//选中物料
					xuanzhongwuliao: '',

					//审批意见
					shenheyijian: '',

					//项目名称
					xiangmuname: null,

					//项目id
					xiangmucode: null,


				},

                sta: null, //对应特价的状态

				xuanzeren: false,

				tableData3: [],


				bizhongListops: [],


				//特价可选物料
				kexuanwuliao: {},

				//项目产品集
				chanpincode: [],


				sizeForm: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},

				rule: {
					category: [{
						required: true,
						message: '请选择特价类型',
						trigger: 'change'
					}],
					xuanzhongren: [{
						required: true,
						message: '请选择使用人',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择区域',
						trigger: 'change'
					}],
					youxiaoqi: [{
						required: true,
						message: '请选择有效期',
						trigger: 'change'
					}],
					tejiashuoming: [{
						required: true,
						message: '请输入特价说明',
						trigger: 'blur'
					}],
					shenheyijian: [{
						required: true,
						message: '请填写审批意见',
						trigger: 'blur'
					}]
				}


			}
		},
		mounted() {

		},


		created() {

			console.log(this.$route.query, 'this.$route.query')


			//币种加载
			this.bizhongjiazai();

			//若有审批
			if (this.$route.query.ywid) {

				//ywid
				this.ywid = this.$route.query.ywid;

				//instid
				this.instid = this.$route.query.instid;

				//taskid
				this.taskid = this.$route.query.taskid;

				//特价版本id
				this.rversion = this.$route.query.ywid;

				//审批信息加载
				this.sehnpijiazai();


			} else if (this.$route.query.chakan) {

				//特价版本id
				this.rversion = this.$route.query.chakan;


				//信息加载
				this.sehnpijiazai();


			} else {

				//普通页面加载
				this.putongjiazai();

			}


		},


		methods: {


			//测算版本查看
			cesuanbanbenchakan() {

				//测算版本有的话
				if (this.cesuanid != null && this.cesuanid != '') {

					var rversion = {

						rversion: this.cesuanid
					}

					//查找测算版本
					ss.FormulaNew.getbanben(rversion).then(rd => {

						console.log(rd.obj, '测算')

						//测算
						this.neiwaixiaopanduan(rd.obj);

					})

				}

			},


			//测算跳转判断
			neiwaixiaopanduan(q) {
				console.log(q, "asdasd????")

				var path = '';

				if (q.neixiaowaixiao == 1 && q.ispro == 1) { //外销项目
					//跳转外销项目
					path = '/xiangmu/entersix';

				} else if (q.neixiaowaixiao == 1 && q.ispro == 0) { //外销工具
					//跳转外销工具
					path = '/xiangmu/enterseven';

				} else if (q.neixiaowaixiao == 0) { //内销
					//跳转内销测算
					path = '/xiangmu/enterfive';

				} else if (q.neixiaowaixiao == 2) { //租赁
					//跳转内销测算
					path = '/rateFormulaZulinshiti';

				}

				var shiti = {
					chakanshiti: q.rversion
				}

				console.log(shiti, 'shitishitishiti')


				let routeData = this.$router.resolve({
					path: path,
					query: shiti
				});
				window.open(routeData.href, '_blank');


			},


			kaishishifu(q) {

				console.log(q, '看看row')

				//如果是折扣
				if (q.tejiafangshi == '2') {

					console.log(q, '看2222')

					this.columndata = [{
						prop: "zhehoujine",
						label: "折后实付金额(基准价*折扣)",
					}]

					q.xianshizhehou = true;

				}


			},


			xunzhaonengyongdengji(q) {

				var canshu = {

					usercode: q,

				}

				ss.xinzengtejianew.xunzhaodengji(canshu).then(rd => {

					console.log(rd, 'rffffgsss')

					if (rd.obj.length <= 0) {

						this.$msg.msge("该内销用户没有可用大类等级");

					} else {

						this.dengjixuanzelist = rd.xuanzelist;

						this.nidmap = rd.nidmap;

					}

				})

			},


			xuanzequyufangfa(q) {

				this.tableData3 = [];

				console.log(q, 'quyuquyu')

				console.log(this.offer.type, 'this.offer.type')


			},

			dblclick(v, h, c, d) {
				console.log(v, h, c, d, '???;;??')
			},


			//查看特价产品使用进度
			tejiachanpinshiyongqingkuang(index, q) {

				//跳转特价产品使用进度
				this.$router.push({
					path: '/price/priceToDetail',
					query: {
						id: q.id
					}
				})

			},

			//跟踪审批
			genzongLiuch() {

				this.showhistory = true;

			},


			//选择项目前监听使用人
			jiantingshiyongren(val) {

				console.log(val, 'aaawwwwsss')

				//如果是项目
				if (this.offer.category == 0 && !this.shenpiyemian && !this.bohuiyemian) {

					if (this.xiangmumingchengOptions.length == 0) {

						this.$msg.msge("使用人无相关项目或未选择使用人")

					}

				}

			},

			//按用户usercode获取用户
			shiyongrenmingcheng(usercode) {

				var entity = {

					usercode: usercode

				}

				ss.UserService.getByModel(entity).then(rd => {

					console.log(rd.result, 'user')

				})

			},

			//通过或驳回 q: 1驳回，2通过
			tongguobohui(q) {

				console.log(this.offer.shenheyijian, 'this.offer.shenheyijian')

				//驳回
				if (q == 1) {

					if (this.offer.shenheyijian != null && this.offer.shenheyijian != '') {

						this.tijiaogengxinzhuangtai(q);

					} else {

						this.$msg.msge("请填写审批意见")

					}

					//通过
				} else if (q == 2) {

					this.tijiaogengxinzhuangtai(q);

				}


			},

			//提交更新审核状态
			tijiaogengxinzhuangtai(q) {

				var sid = {
					sid: this.rversion,
					taskid: this.taskid,
					optflag: q == 1 ? '驳回' : '通过',
					msg: this.offer.shenheyijian,
					tongguoorbohui: q, //通过还是驳回 1驳回  2通过

				}

				ss.specialController.tongguoshenhe(sid).then(rd => {
					if (rd.f == true) {
						this.$msg.alerts("提交成功！", () => {
							//刷新右上角的代办个数
							this.$store.dispatch("searchTasktotal")
							//跳转回系统的代办列表
							this.$router.push({
								path: '/personal/dealCenter'
							})
						})
					}

				})
			},


			//重新提交
			chongxintijiao() {

				//判断一下高低价
				if (this.panduangaodijia()) {

					this.$msg.alerte("低价特价版本请移步至: **盈利测算模块--工具版/海外工具版** 发起具体的测算申请，审批通过后将生成低价特价版本", () => {

					})

				} else {

					if (this.zancuntijiaobanben != null) {

						var offer = {

							specialId: this.zancuntijiaobanben

						}

						console.log("obj-2");

						//先删除
						ss.xinzengtejianew.luojishanchu(offer).then(rd => {

							//若删除成功了
							if (rd.f == true) {

								// this.zancuntijiaobanben = this.$util.getUuid();
								console.log("obj-3");

								for (var d in this.tableData3) {

									this.tableData3[d].id = null;

								}

								//再提交
								this.zancuntijiao(1);

							}

						})


					}


				}


			},


			//审批加载
			sehnpijiazai() {

				var ywid = {

					ywid: this.rversion,

				}

				ss.xinzengtejianew.shenpijiazai(ywid).then(rd => {

					console.log(rd.obj, "看看保存的");
					this.sta = rd.obj.status;
					console.log(this.sta, "wtffffffffffffffffffff");

					if (rd.f == true) {

						var val = {

							userName: rd.obj.username,
							currency: rd.obj.currency,
							custagentgroup: 0 == rd.obj.leltypecode ? "0260" : 1 == rd.obj.leltypecode ? "0280" : null,
							usercode: rd.obj.userCode,

						}

						//加载使用人选择信息
						this.shiyongrenxuanze(val);

						//加载信息
						this.jiazaixinxi(rd.obj);

					} else {

						this.$router.push({
							path: '/pricenewCG'
						})

					}


				})

			},

			//加载信息
			jiazaixinxi(offer) {

				console.log(offer.shenpijindu, 'offer.shenpijindu')

				//是不是驳回的
				if (offer.bohui == 1) {

					//是驳回
					this.bohuiyemian = true;

					//如果发现登陆人的节点其他人已经被驳回了直接跳转走
					if (offer.tiaozhuango != null && offer.tiaozhuango == 1) {
						this.$msg.msge("该审批已被驳回")
						this.$router.push({
							path: "/personal/dealCenter"
						})
					}

					//不是驳回的话有业务id就是审批页面了
				} else if (this.ywid != null) {

					//是审批页面
					this.shenpiyemian = true;

				}

				//已经通过审批的就是正常查看页面
				if (offer.status == 2 && this.ywid == null) {

					this.chakanyemian = true;

					//已提交审批并且不是在审批或者驳回的页面上
				} else if (offer.bohui != 1 && (offer.status != 0 && offer.status != 2 && this.ywid == null)) {

					this.yitijiaoshenpi = true;

				}


				//如果有instid就可以显示记录
				if (offer.instid != null) {

					this.showhistoryid = offer.instid;

				}


				this.tableData3 = [];

				this.offer.category = offer.category;

				this.offer.userCode = offer.userCode;

				this.offer.xuanzhongren = offer.username;

				this.offer.cucode = offer.cucode;

				this.offer.cuname = offer.cuname;

				this.offer.cdate = offer.cdate;

				this.offer.pid = offer.pid;

				this.offer.youxiaoqi = [offer.startdate, offer.validity];

				this.offer.shenheyijian = this.bohuiyemian == true ? offer.shenpijindu != null ? offer.shenpijindu.split("_").length ==
					3 ? offer.shenpijindu.split("_")[2] : '' : '' : '';

				this.offer.tejiashuoming = offer.tejiashuoming;

				this.zancuntijiaobanben = offer.specialId;

				this.offer.leltypecode = offer.leltypecode; //海外0区域   /1 国内经销商级别

				this.offer.type = offer.type; //海外 区域   国内 级别

				if (offer.fileid) {
					this.fujianId = offer.fileid; //上传的附件
				} else {
					this.fujianId = offer.specialId; //上传的附件
				}

				//存在测算转化版本
				if (offer.rversion) {

					//测算版本
					this.cesuanid = offer.rversion;

					//显示测算查看
					this.cesuanshow = true;

					this.cailiaomaoli = offer.cesuanmap.cailiaomaoli;
					this.jingyinggongxian = offer.cesuanmap.jingyinggongxian;
					this.jingyinggongxianlv = offer.cesuanmap.jingyinggongxianlv;
					this.lirun = offer.cesuanmap.lirun;
					this.lirunlv = offer.cesuanmap.lirunlv;

				}


				//存在项目信息
				if (offer.proMain) {

					//项目名称
					this.offer.xiangmuname = offer.proMain.projectName;

					//项目id
					this.offer.xiangmucode = offer.proMain.id;

					//显示项目信息
					this.xiangmuxinxishow = true;
				}

				if (offer.detailList != null && offer.detailList.length > 0) {

					for (var d in offer.detailList) {

						var list = {

							leltypecode: 1,
							type: '01',
							id: offer.detailList[d].id,
							proCode: offer.detailList[d].productId,
							proProductInfoid: offer.detailList[d].proProductInfoid,
							hid: offer.detailList[d].hid,
							materialDescrition: offer.detailList[d].materialDescrition,
							tejiafangshi: '1',
							jineorzhekou: offer.detailList[d].proDiscPrice,
							bizhong: 'CNY',
							avaiNumber: offer.detailList[d].avaiNumber,
							totalNumber: offer.detailList[d].totalNumber,
							bizhongjihe: [],
							dingjia: offer.detailList[d].unitPrice,
							proDiscPrice: offer.detailList[d].jineorzhekou,
							dingjiaid: offer.detailList[d].dingjiaid ? offer.detailList[d].dingjiaid : null,
							dingjialist: offer.detailList[d].dingjialist || null,
							dingjiakexuan: true,
							xianshizhehou: false,
							zhehoujine: '',
							productId: offer.detailList[d].proCode,
							productName: offer.detailList[d].materialDescrition,
							unitPrice: offer.detailList[d].dingjia,
							ccode: offer.detailList[d].proCode,
							cdate: offer.detailList[d].proCode,

						}


						for (var t in this.bizhongListops) {

							if (this.bizhongListops[t].code == offer.detailList[d].bizhong) {

								list.bizhongjihe.push({

									label: this.bizhongListops[t].name,
									value: offer.detailList[d].bizhong,

								})

							}

						}


						this.tableData3.push(list);

					}

				}


				//是项目的话
				if (offer.category == 0) {

					console.log("走没走这个", "aa")

					//加载项目名称下拉选框
					this.anrenyuanxuanzexiangmu(offer.userCode);

					//加载项目产品
					this.xiangmumingchengchangetype(offer.pid);

				}

				console.log(this.tableData3, 'this.tableData3')


			},

			//普通加载
			putongjiazai() {

				//版本id设置
				// this.zancuntijiaobanben = this.$util.getUuid();

				//上传附件编码
				this.fujianId = this.$util.getUuid();

			},

			//切换金额折扣
			qiehuanjinezhekou(row) {

				console.log(row, 'rowppp')

			},

			//选择币种时同时加载对应币种定价
			jiazaidingjia(val) {

				console.log(val, '有没有')

				var entity = {

					materialid: val.proCode, //物料号
					currency: val.bizhong, //币种

				}

				if (this.offer.category != 4) {

					entity.type = this.offer.type; //使用人的区域编码或者级别
					entity.leltypecode = this.offer.leltypecode; //区域0  级别1

				}

				//如果没选区域先选区域
				if (this.offer.category != 4 && (this.offer.type == null || this.offer.type == '')) {

					this.$msg.msge("请选择区域")

					val.bizhong = '';

				} else {

					console.log(entity, 'entityaaa')

					ss.xinzengtejianew.finddingjia(entity).then(rd => {

						console.log(rd.obj, 'uuuu')

						var dingjialist = []

						for (var d in rd.obj) {

							if (this.offer.category == 5 && val.tejiafangshi == 1) {
								if (val.jineorzhekou > rd.obj[d].value) {
									this.$msg.msge("申请特价不应低于基准价格")

								}
							}
							dingjialist.push({

								label: "金额:" + rd.obj[d].value + ' 有效期:' + rd.obj[d].startdate + '至' + rd.obj[d].effectivedate,
								value: rd.obj[d].id + "_" + rd.obj[d].value,

							})

						}

						console.log(dingjialist, 'dingjialist')

						val.dingjialist = dingjialist;
						console.log(val.dingjialist, 'val.dingjialist')

						console.log(this.tableData3, 'tableData3')

						//若只有一个可用定价，默认选中
						if (dingjialist.length == 1) {

							val.dingjia = dingjialist[0].value;
							val.dingjiakexuan = true;

							//没有定价
						} else if (dingjialist.length == 0) {

							this.$msg.msge("该币种无对应定价，请重新选择")

							val.bizhong = '';

							val.dingjia = '';

							val.dingjialist = [];

							//todo 曹经理让只要有有效期内重复的定价，先默认只选中一条 20191225
						} else if (dingjialist.length > 1) {

							val.dingjia = dingjialist[0].value;
							val.dingjiakexuan = true;

						}

					})

				}


			},


			//项目产品选择
			chanpincodechange(val) {

				console.log(val, '+++产品')

				console.log(this.xiangmuchanpinmap[val.proProductInfoid], '???')

				val.avaiNumber = this.xiangmuchanpinmap[val.proProductInfoid].productNum;
				val.productId = this.xiangmuchanpinmap[val.proProductInfoid].productId;
				val.productName = this.xiangmuchanpinmap[val.proProductInfoid].productName;
				val.unitPrice = this.xiangmuchanpinmap[val.proProductInfoid].unitPrice;
				val.ccode = this.xiangmuchanpinmap[val.proProductInfoid].ccode;
				val.cdate = this.xiangmuchanpinmap[val.proProductInfoid].cdate;



				console.log(this.bizhongListops, 'this.bizhongListops')

				console.log(this.xiangmuchanpinmap, 'this.xiangmuchanpinmap')

				for (var t in this.bizhongListops) {

					if (this.bizhongListops[t].code == val.bizhong) {

						val.bizhongjihe.push({

							label: this.bizhongListops[t].name,
							value: val.bizhong,

						})

					}
				}


			},

			//弹出选择物料
			tanchuwuliao() {
				this.xuanwuliao = true;
			},

			//判断物料是否能被选中
			shifouxuanzhong(val) {

				//是否能选中
				var yes = false;

				//若是采购特价
				if (this.offer.category == 13) {

					//遍历级别:(大类集合)
					for (var m in this.nidmap) {

						//如果有跟现在选择的级别一致的级别
						if (this.offer.type == m) {

							//遍历大类集合
							for (var f in this.nidmap[m]) {

								//若该选中物料的大类在集合中存在  或者大类集合中存在ct可全选
								if ((val.cpdlcode == this.nidmap[m][f]) || this.nidmap[m][f] == 'ct') {

									//设为可选中
									yes = true;

								}

							}

						}

					}


				}

				return yes;

			},

			//选择产品型号的方法
			chanpinxinghaochangetype(val) {
				console.log(val, '+++物料');
				console.log(this.zancuntijiaobanben, 'sid');
				this.tableData3.push({
					productId: val.productId,
					productName: val.productName,
					unitPrice: val.unitPrice,
					ccode: val.ccode,
					cdate: val.cdate,
					hid: val.oneLid,
					bizhong: 'CNY',
					avaiNumber: '',
					sid: this.zancuntijiaobanben,
				})
				console.log(this.tableData3, 'this.tableData3')
				this.xuanwuliao = false;
			},


			//特价类型选择
			tejialeixingxuanze(val) {


				this.offer.type = '';

				this.offer.leltypecode = '';

				this.offer.userCode = '';

				this.tableData3 = [];

				this.offer.xuanzhongren = '';

				this.offer.pid = '';

				this.xiangmumingchengOptions = [];

				console.log(val, 'aa')

				if (val == null) {

					this.offer.category = null;

				}

				//项目特价
				if (val && val.code == 0) {


					//特殊直扣
				} else if (val && val.code == 13) {


					//台阶政策
				} else if (val && val.code == 4) {

					//加载可选物料
					this.jiazaikexuanwuliao(null);

				}

			},

			//返回上页
			fanhuishangye() {

				//跳转
				this.$router.push("/pricenewCG");

			},


			//判断重复信息
			panduanchongfuxinxi() {

				//todo
				return false
			},


			//判断特殊直扣的高低价
			panduangaodijia() {

				var yes = false;

				//特殊直扣
				if (this.offer.category == 13) {

					for (var s in this.tableData3) {

						var fangshi = this.tableData3[s].tejiafangshi;
						var jine = this.tableData3[s].jineorzhekou;
						var dingjia = this.tableData3[s].unitPrice;

						//金额
						if (fangshi == '1') {

							if (parseFloat(jine) > parseFloat(dingjia)) {

								yes = true;

							}

							//折扣
						} else if (fangshi == '2') {

							if (parseFloat(jine) < 1.0) {

								yes = true;

							}

						}


					}

				}

				return yes;

			},


			//暂存或提交
			zancuntijiao(q) {

			    for (var c in this.tableData3) {
			        this.tableData3[c].totalNumber = this.tableData3[c].avaiNumber;
			    }

				if (this.tableData3.length > 0) {

					//判断数据完整和正数和小数
					var yes = this.panduanxiaoshu();

					//若有不符合输入的
					if (yes) {

						//判断折扣输入是否标准
						if (this.zhekoupanduan) {
							this.$msg.msge("折扣必须输入小数")

							//判断其他输入是否标准
						} else {
							this.$msg.msge('请输入正确的特价信息')
						}

						//没问题的
					} else {

						console.log(this.tableData3, '提交数据')

						//todo 判断重复
						var shifouchongfu = this.panduanchongfuxinxi();

						//若有重复或无效的
						if (shifouchongfu) {

							this.$msg.msge("有重复及无效信息请修改")

							//没问题的
						} else {

							//暂存
							if (q == 0) {

								//暂存
								this.zancuntongdao(q);

								//提交
							} else if (q == 1) {

								//提交
								this.tijiaotongdao(q);

							}


						}


					}

				} else {

					this.$msg.msge('请先添加特价行信息')

				}

			},


			//暂存按钮
			zancuntongdao(q) {
				//创建暂存
				ss.xinzengtejianew.chuangjiantejia(this.gouzaocanshu(q)).then(rd => {
					console.log(rd.obj, 'kankanfanhui')
					if (rd.f == true) {
						this.$msg.msgs("保存成功")
						this.$router.push("/pricenewCG");
					}
				})
			},

			//提交通道
			tijiaotongdao(q) {
				//提交
				ss.xinzengtejianew.tejiaotejia(this.gouzaocanshu(q)).then(rd => {
					console.log(rd.obj, 'kankanfanhui')
					if (rd.f == true) {
						this.$msg.alerts("提交成功！", () => {
							//跳转
							this.$router.push({
								path: '/pricenewCG'
							})
						})
					}
				})
			},

			//逻辑删除
			luojishanchu(specialId, ids) {

				var offer = {}

				if (specialId != null) {

					offer.specialId = specialId;

				}

				if (ids != null && ids.length > 0) {

					var detaillist = []

					for (var i in ids) {

						detaillist.push({

							id: ids[i]

						})

					}

					offer.detaillist = detaillist;

				}


				//逻辑删除
				ss.xinzengtejianew.luojishanchu(offer).then(rd => {

				})


			},


			//构造参数
			gouzaocanshu(q) {

				var offer = {

					specialId: this.zancuntijiaobanben,
					pid: this.offer.category == 0 ? this.offer.pid : null,
					category: this.offer.category,
					startdate: this.offer.youxiaoqi == null ? null : (this.offer.youxiaoqi[0] == '' || this.offer.youxiaoqi[0] ==
						null) ? '' : this.$util.riQi(this.offer.youxiaoqi[0]),
					validity: this.offer.youxiaoqi == null ? null : (this.offer.youxiaoqi[1] == '' || this.offer.youxiaoqi[1] == null) ?
						'' : this.$util.riQi(this.offer.youxiaoqi[1]),
					status: q,
					tejiashuoming: this.offer.tejiashuoming,
					userCode: this.offer.userCode || null,
					userCatecory: 1,
					bohui: 0,
					fileid: this.fujianId

				}

				var detaillist = []

				for (var d in this.tableData3) {

					console.log("this.tableData3[d]", this.tableData3[d])

					detaillist.push({

						id: this.tableData3[d].id || null,
						sid: this.zancuntijiaobanben,
						pid: this.offer.category == 0 ? this.offer.pid : null,
						proCode: this.tableData3[d].productId,
						leltypecode: 1,
						type: '01',
						proProductInfoid: this.offer.category == 0 ? this.tableData3[d].proProductInfoid : null,
						tejiafangshi: '1',
						proDiscPrice: this.tableData3[d].jineorzhekou,
						proDiscount: this.tableData3[d].jineorzhekou / this.tableData3[d].unitPrice,
						bizhong: 'CNY',
						avaiNumber: this.tableData3[d].avaiNumber,
						totalNumber: this.tableData3[d].totalNumber,
						upfilenames: this.zhengmingziliao,
						dingjiaid: null,
						dingjia: this.tableData3[d].unitPrice,

					})

				}


				offer.detailList = detaillist;

				console.log(offer, 'offer')

				return offer
			},

			//判断数据完整和正数和小数
			panduanxiaoshu() {

				this.zhekoupanduan = false;

				var yes = false;

				for (var c in this.tableData3) {

					//非空排查
					if (this.tableData3[c] == null || this.tableData3[c] == '' || this.tableData3[c].avaiNumber <= 0 || this.tableData3[
							c].productId == null || this.tableData3[c].productId == '') {

						console.log(this.tableData3, 'this.tableData3非空')

						console.log(c, 'ccc')
						console.log('非空')
						yes = true;

					}

					for (var f in this.tableData3[c]) {

						//销量
						if (f == 'avaiNumber' && this.offer.category != 4) {

							if (/^\d+(.\d+)?$/.test(this.tableData3[c][f]) == false) {

								console.log('销量')
								yes = true;

							}

						}

						//折扣
						if (f == 'jineorzhekou' && this.tableData3[c].tejiafangshi == 2) {


							if (/^[0-9].\d+$/.test(this.tableData3[c][f]) == false) {

								console.log('折扣')
								yes = true;
								this.zhekoupanduan = true;

							}

						}

						//金额
						if (f == 'jineorzhekou' && this.tableData3[c].tejiafangshi == 1) {


							if ((/^\d+.\d+$/.test(this.tableData3[c][f]) == false) && (/^\d+$/.test(this.tableData3[c][f]) == false)) {

								console.log('金额')
								yes = true;

							}

						}


					}

				}

				//有效期
				if (this.offer.category != 4 && (this.offer.youxiaoqi == null || this.offer.youxiaoqi == '' || this.offer.youxiaoqi
						.length < 2 || this.offer.youxiaoqi[0] == null || this.offer.youxiaoqi[0] == '' || this.offer.youxiaoqi[1] ==
						null || this.offer.youxiaoqi[1] == '')) {

					console.log('有效期')
					yes = true;

				}

				return yes
			},


			//币种加载
			bizhongjiazai() {


				ss.Dictservice.listbycategory("YLCurrency").then(rd => {

					console.log(rd, '字典结果')
					this.bizhongListops = rd;

				})

			},


			//加载可选物料
			jiazaikexuanwuliao(q) {

				var qer = [];

				if (q != null) {

					qer = q;

				}

				this.wuliaocode = [];

				//获取可以选择的物料map
				ss.xinzengtejianew.findkexuanwuliao(qer).then(rd => {

					console.log(rd.obj, 'obj')

					this.kexuanwuliao = rd.obj;

					for (var c in rd.obj) {

						if (rd.obj[c][0].materialdescritionSystem) {

							this.wuliaocode.push({

								value: c,
								label: rd.obj[c][0].materialdescritionSystem,

							})

						} else if (rd.obj[c][0].materialdescritionMdm) {

							this.wuliaocode.push({

								value: c,
								label: rd.obj[c][0].materialdescritionMdm,

							})

						}

					}

				})

			},

			//切换项目名称的方法
			xiangmumingchengchangetype(val) {

				console.log(val, 'pid');

				var pid = {

					pid: val

				}

				//获取项目对应项目产品
				ss.xinzengtejianew.findxiangmuchanpin(pid).then(rd => {

					this.xiangmuchanpinmap = rd.obj;

					console.log(rd.obj, 'rd.obj')

					for (var t in rd.obj) {

						this.chanpincode.push({

							label: rd.obj[t].productName,
							value: t,

						})


					}


				})

			},


			tanchuxuanzeren() {
				this.offer.type = '';
				this.xuanzeren = true;
				// dialogFormVisible
			},
			//选择使用人
			shiyongrenxuanze(val) {
				console.log(val, '+++使用人')
				this.xuanzeren = false;
				this.offer.userCode = val.usercode;
				this.offer.xuanzhongren = val.userName;
				this.offer.leltypecode = "0260" == val.custagentgroup ? 0 : "0280" == val.custagentgroup ? 1 : null; //海外0区域   /1 国内经销商级别
				// this.offer.type = "0260" == val.custagentgroup ? '' : "0280" == val.custagentgroup ? val.jxsjb : null;//海外 区域   国内 级别
				this.shiyongrenbizhong = val.currency; //使用人的币种

				//是否选区域
				this.xuanzequyu = "0260" == val.custagentgroup ? true : false;

				//是否选等级
				this.xuanzedengji = "0280" == val.custagentgroup ? true : false;


				if ("0280" == val.custagentgroup) {

					//加载能选等级
					//this.xunzhaonengyongdengji(val.usercode);

				}


				//换项目
				this.anrenyuanxuanzexiangmu(val.usercode);
			},


			//按人员选项目
			anrenyuanxuanzexiangmu(q) {
				this.xiangmumingchengOptions = [];
				var id = {
					id: q
				}
				ss.specialController.anrennaxiangmu(id).then(rd => {
					console.log(rd.obj, '看看有啥')
					//加载项目名称下拉选框
					for (var ss in rd.obj) {
						var cus = {
							value: rd.obj[ss].id,
							label: rd.obj[ss].projectName,
						}
						this.xiangmumingchengOptions.push(cus);
					}
				})
			},


			//逻辑删除特价产品
			shanchuchanpinfangfa(q) {

				var entity = {

					id: q,
					delflag: 0,

				}

				ss.specialController.luojishanchuchanpin(entity).then(rd => {

					if (rd.f == true) {

						this.$msg.msgs("删除成功")

					}

				})

			},


			//删除框
			delPlan(index, q) {

				console.log(q, 'qaaaaa')

				this.$confirm('确认删除？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					})
					.then(_ => {

						//如果原来有数据
						if (q.id != null) { //把要删除的主键id存起来
							this.yaoshanchude.push({
								id: q.id
							});

							//查看页面
							if (this.chakanyemian == true) {

								//逻辑删除特价产品
								this.shanchuchanpinfangfa(q.id);

							}

						}
						this.tableData3.splice(index, 1)
						//console.log(index,"删除一行数据");

					})
					.catch(_ => {

					});

			},


			expoType(v) {
				if (v.expoType == "1") {
					v.expoPrice = "";
				} else {
					v.expoDiscount = "";
				}
			},
			// //表格 只能输入数字方法
			// onlynumber(scope){
			// 	let ex = /^[1-9][0-9]*$/
			// 	if(ex.test(scope.amount)){
			//
			// 	}else{
			// 		scope.amount = 1;
			// 	}
			// },

			addfilecallbackpo() {},
			delIndex(index) {},

			//增加行
			adds() {
				//若已选使用人code
				if (this.offer.userCode) {
					//弹出物料选择框
					this.tanchuwuliao();
					//若没选
				} else {
					this.$msg.msge("请先选择供应商")
				}
			},

			//时间限制
			beginDate(v) {
				if (v.purchaseDate) { //如果结束时间不为空，则小于结束时间
					if (v.purchaseDate < v.exfactoryDate) {
						this.$msg.msge("购买日期不能小于出厂日期");
						v.exfactoryDate = "";
					}
				}
			},
			processDate(v) {
				if (v.exfactoryDate) { //如果有出厂日期
					//如果购买日期小于出厂日期
					if (v.purchaseDate < v.exfactoryDate) {
						this.$msg.msge("购买日期不能小于出厂日期");
						v.purchaseDate = "";
					}
				}
			}
		},
	}
</script>


<style scoped>
	.n-bu .el-input--suffix .el-input__inner {
		padding-left: 45px;
	}

	.n-bu .h-formbLine .h-elformWrap-2,
	.n-chan .h-formbLine .h-elformWrap-2 {
		width: 33.333%;
	}

	.pieceCon,
	.product {
		width: 92%;
		border-radius: 4px;
	}

	h1 {
		margin-left: 15px;
	}

	.N-chan .h-pieceTitle2 {
		margin-bottom: 0.4rem;
		margin-left: 0;
	}

	.bigDiv {
		margin: 20px;
	}
</style>
<style>
	.el-date-editor .el-range-separator {
		padding: 0 5px;
		line-height: 15px;
		width: 5%;
		color: #303133;
	}

	.el-radio__label {
		font-size: 0.23rem;
	}

	.block .el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 168px;
	}

	.n-bu .h-formbLine .el-form-item__label {
		width: 47%;
		vertical-align: top;
	}

	.n-bu .h-formbLine .el-form-item__content {
		width: 53%;
	}

	.n-bu .h-formbLine .h-elformWrap-3 {
		width: 100%;
	}

	.n-bu .h-formbLine .h-elformWrap-3 .el-form-item__label {
		width: 10.7%;
	}

	.n-bu .h-formbLine .h-elformWrap-3 .el-form-item__content {
		width: 73.3%;
	}

	.yxtable .el-table tbody td .cell {
		padding: 0.05rem 0.1rem;
	}

	.yxtable .h-tableInput .el-input__inner {
		padding: 0.05rem 0.1rem;
	}

	.yxtable .el-date-editor .el-range-separator {
		line-height: 0.26rem;
		font-size: 0.16rem;
	}

	.ljjtable .el-table .el-input--suffix .el-input__inner {
		font-size: 0.16rem;
	}

	.ljjtable .el-table .el-input__inner {
		font-size: 0.16rem;
	}

	.ahstyles .el-input.is-disabled .el-input__inner {
		background: transparent;
		color: #616467;
	}
</style>


<style scoped lang="scss">
	$ft-colorg: #21d16f; //绿色的字
	$ft-coloro: #e79118; //黄色的字
	$bg-colorg: #f6fffa; //绿色的背景色
	$bg-coloro: #fffbf7; //黄色的背景色
	$bg-colorb: #3b77fc; //蓝色
	$bg-colorgrey: #c3c3c3; //灰色

	.yx_progressBar {
		width: 100%;
		border: 1px solid $ft-colorg;
		background-color: $bg-colorg;
		padding: 0.38rem;
		position: relative;

		.yxExtra {
			position: absolute;
			color: $ft-colorg;
			top: 0.3rem;
			font-size: 0.18rem;
			right: 0.3rem;
		}

		.yx_topTip {
			display: flex;
			justify-content: flex-start;
			color: #424441;
			font-size: 0.18rem;

			.leftdes {
				margin-right: 0.75rem;
			}

			.percent {
				color: $ft-colorg;
			}
		}

		.con_progress {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 0.3rem;

			.eve_proout {
				display: flex;
				align-items: center;
				justify-content: flex-start;

				&:last-child .line_pro {
					display: none;
				}

				.eve_pro {
					width: 20px;
					height: 20px;
					border-radius: 50%;
					position: relative;
					background-color: $bg-colorgrey;

					.persons {
						position: absolute;
						top: 20px;
						min-width: 1.8rem;
						text-align: center;
						margin-left: -0.75rem;
						margin-top: 0.04rem;
						font-size: 0.18rem;
					}

					.personsAc {
						color: $bg-colorb;
					}
				}


				.line_pro {
					width: 3rem;
					height: 4px;
					background-color: $bg-colorgrey;
				}

				// 激活
				.eve_proAc {
					background-color: $bg-colorb;
				}

				.line_proAc {
					width: 3rem;
					height: 4px;
					background-color: $bg-colorb;
				}

				.eve_proAcpass {
					background-color: $bg-colorgrey;
				}

				.line_proAcpass {
					width: 3rem;
					height: 4px;
					background-color: $bg-colorb;
				}
			}

		}
	}

	.yx_progressBarAc {
		border: 1px solid $ft-coloro;
		background-color: $bg-coloro;

		.yxExtra {
			color: $ft-coloro;
		}

		.yx_topTip {
			.percent {
				color: $ft-coloro;
			}
		}
	}


	.zancun {
		background-color: #24b5b8;
		color: white;
	}

	.product {
		margin-top: 10px;

	}

	.Ptitle {
		margin-top: 30px;
	}

	.resultA {
		border: 1px solid rgb(104, 184, 108);
		background-color: rgb(224, 233, 224);
		color: rgb(126, 216, 130);
	}

	.resultA,
	.resultB {
		width: 100%;
		height: 150px;
		border-radius: 4px;
		margin: 20px 0;
	}

	.resultB {
		border: 1px solid rgba(233, 161, 52, 0.925);
	}

	h6>span {
		color: greenyellow;
	}

	h6>.span {
		color: rgba(233, 161, 52, 0.925);
	}

	.xia {
		display: flex;
		justify-content: center;
		margin-top: 0.7rem
	}
</style>
